import { makeStyles } from '@material-ui/core';
import colors from '../../../../styles/colors';

const useStyles = makeStyles((theme) => ({
  card: {
    position: 'relative',
    height: '100%',
    padding: theme.spacing(1.5, 2),
    borderRadius: '4px',
    cursor: 'pointer',
    border: (props) =>
      `1px solid ${props.isChecked ? '#39C395' : colors.greyScale[8]}`,
    backgroundColor: (props) =>
      props.isChecked ? 'rgba(57, 195, 149, 0.08)' : '#fff'
  },
  checkIcon: {
    position: 'absolute',
    top: theme.spacing(1),
    right: theme.spacing(1),
    color: '#39C395'
  },
  label: {
    fontWeight: 'bold',
    color: colors.greyScale[2]
  },
  description: {
    fontSize: '12px',
    color: colors.greyScale[5]
  }
}));

export default useStyles;
